module.exports = __webpack_public_path__ + "img/Pluto.c385d1ae.jpg";